import { useEffect } from "react";

import AscButton from "../../../../AscButton/AscButton";
import AscHeading from "../../../../AscTypography/AscHeading/AscHeading";
import AscAddActivityQuestionAnswerCard from "../../../../AscCards/AscAddActivityQuestionAnswerCard/AscAddActivityQuestionAnswerCard";

import styles from "./AscActivityQuizDragDrop.module.scss";
import { useAscAddModuleActivitiesForm } from "../../useAscAddModuleActivitiesForm";
import { v4 as uuidv4 } from "uuid";
export default function AscActivityQuizDragDrop() {
  const formik = useAscAddModuleActivitiesForm();

  function handleChange({ answer }: { answer?: string }, index: number) {
    const newCards = [
      ...(formik?.values?.quizDragDrop?.questions?.questions?.answers || []),
    ];
    newCards[index] = {
      id: newCards[index]?.id,
      value: answer || "",
      image: newCards[index]?.image,
    };
    formik.setFieldValue(`quizDragDrop.questions.questions.answers`, newCards);
  }

  function handleDelete(index: number) {
    const newCards = [
      ...(formik?.values?.quizDragDrop?.questions?.questions?.answers || []),
    ];
    newCards.splice(index, 1);
    if (newCards.length === 0) {
      newCards.push({
        id: uuidv4(),
        value: "",
      });
    }
    formik.setFieldValue(`quizDragDrop.questions.questions.answers`, newCards);

    // Handle remove image
    const newImages = [...(formik?.values?.quizDragDrop?.image || [])];
    newImages.splice(index, 1);
    formik.setFieldValue(`quizDragDrop.image`, newImages);
  }

  function handleImageUpload(image: File, index: number) {
    formik.setFieldValue(`quizDragDrop.image[${index}]`, image);
  }
  function handleImageRemove(image: File, index: number) {
    formik.setFieldValue(`quizDragDrop.image[${index}]`, undefined);
  }

  function addCard() {
    formik.setFieldValue(`quizDragDrop.questions.questions.answers`, [
      ...(formik?.values?.quizDragDrop?.questions?.questions?.answers || []),
      {
        id: uuidv4(),
        value: "",
      },
    ]);
  }

  useEffect(() => {
    if (
      formik?.values?.quizDragDrop?.questions?.questions?.answers?.length === 0
    ) {
      addCard();
    }
  }, []);

  return (
    <div className={styles.ground}>
      <div className={styles.headerGround}>
        <AscHeading className={styles.header} level={6}>
          Question / Answer cards
        </AscHeading>

        <AscButton
          className={styles.link}
          variant="link"
          hideLinkIcon={true}
          onClick={addCard}
        >
          Add card <span>+</span>
        </AscButton>
      </div>
      <div className={styles.cards}>
        {formik?.values?.quizDragDrop?.questions?.questions?.answers?.map(
          (card, index: number) => (
            <AscAddActivityQuestionAnswerCard
              key={index}
              className={styles.card}
              value={{
                answer: card?.value,
              }}
              onChange={(card) => handleChange(card, index)}
              canDelete
              onDelete={() => handleDelete(index)}
              image={formik.values.quizDragDrop?.image?.[index]}
              onImageUpload={(image) => handleImageUpload(image, index)}
              onImageRemove={(image) => handleImageRemove(image, index)}
              type={"quizDragDrop"}
            />
          )
        )}
      </div>
    </div>
  );
}
